export const CUSTOMER_ROLE_COMPANY_ADMIN = 'company_admin' as const
export const CUSTOMER_ROLE_SHIPMENTS_VIEWER = 'shipments_viewer' as const
export const STAFF_ROLE = 'staff' as const
